import React, { useCallback, Fragment } from 'react';
import { Route } from '@nackle/biw-web-router';
import { useTranslations } from '../hooks';

export const RoutesProvider = ( { render } ) => {

    const { getString, keyExists } = useTranslations();

    /**
     * Sets the window label given a translation key. The translated label is then
     * pulled out of the `intl-tools` store if it exists.
     * 
     * @param { string } translationKey - The key of the text to retrieve from the language bundle currently loaded.
     * @returns { boolean }
     */
    const setDocumentTitle = useCallback( ( translationKey ) => {
        const isValidKey = keyExists( translationKey );
        if ( isValidKey ) {
            const translatedValue = getString( translationKey );
            document.title = translatedValue;
            return true;
        } else {
            document.title = 'Course Studio';
            return false;
        }
    }, [ getString, keyExists ] );

    return (
        <Route render={ ( route ) => {
            let routeData = route?.match;

            // Attempt to update the window's title.
            setDocumentTitle( routeData?.documentTitle );

            return ( render ) ? render( route ) : <Fragment />;
        } }/>
    );
};
